<ng-container *ngIf="!loading">
    <div class="valueset-header Flexbox Flexbox__flex-1">
        <span class="icon__dls-navigation-left-x-bold-32" (click)="redirectToDashboard()"></span>
        <div class="valueset-info">
            <div class="resource-name-wrapper">
                <span class="resource-name"> {{getValuesetName()}} </span>
            </div>
            <div class="icons-placeholder">
                <div class="icon-wrapper" genTooltip [tooltipPosition]="'TOP'" [tooltipText]="getTooltip(popups.description.name)" tooltipShow="true">
                    <span class="icon__InformationCircleOutline valueset-description-icon {{ disablePopup(popups.description.name) }}"
                          (click)="openValuesetPopup(popups.description.name, $event)"></span>
                </div>
                <div class="icon-wrapper" genTooltip [tooltipPosition]="'TOP'" [tooltipText]="getTooltip(popups.notes.name)" tooltipShow="true">
                    <span class="icon__Notes valueset-note-icon {{ disablePopup(popups.notes.name) }}"
                          (click)="openValuesetPopup(popups.notes.name, $event)" ></span>
                </div>
            </div>
            <span class="last-updated-date"> Last updated:
                <span>{{lastUpdatedDate}}</span>
            </span>
        </div>
        <div class="valueset-action-buttons">
            <ng-container *ngFor="let item of actionsArray()" >
                <button dlsButton *ngIf="item.enabled" class="valueset-action-label {{item.id}}" (click)="changeValueActiveState(item.id)"
                [disabled]="item.disable" [ngClass]="{'disabled': item.disable}">
                    {{item.text}}
                    <span (click)="showNotification($event, item.id)"> ( {{getItemsQtty(item.id)}} ) </span>
                </button>
            </ng-container>
            <notification-container  key="template"></notification-container>
            <ng-template #notification let-message>
                <div class="pt-notification-item-content valueset-notification">
                    <button dlsButton tabindex="0" class="pt-clear-button close-notification-btn" (click)="close(message)" (keydown.enter)="close(message)">
                        <dls-icon class="icon-dls-cross"></dls-icon>
                    </button>

                    <div class="pt-notification-item-text-content notification-body">
                        <span class="title">Selected for {{actionItemId === valuesetActions.activate.id ? 'activation' : 'deactivation'}}:</span>
                        <div class="items-list">
                            <p *ngFor="let nItem of getItems(); let i=index" class="item">{{i+1}}. {{nItem.display}}</p>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
        <span class="vertical-line"></span>
        <div class="valueset-search angucomplete-holder" id="valueset-search">
            <gen-search-field class="search-box" (valueChange)="onSearchChange($event)"
                              (clearEmit)="onSearchClear($event)"
                              (searchEmit)="onSearchExecute($event)"
                              [placeholder]="'Search' | translate"
                              [autoSearch]="true"
                              [selfHandler]="false"
                              [loading]="loading"
                              [value]="">
            </gen-search-field>
        </div>

        <div class="add-btn" *ngIf="enableWrite">
            <gen-button class="add-valueset-item-button"
                        (click)="addNewItem($event)"
                        [iconClass]="'icon__Plus1 add-valueset-item-icon'"
                        [text]="addBtnLabel"
                        [disabled]="allValues.length === 0"
            ></gen-button>
        </div>
    </div>
<!-- TODO: check the need of the bottom border
    <hr class="h-separator"/>-->

    <gen-worklist class="worklist" style="height: 100%"
                  [values]="values"
                  [searchPropagation]="false"
                  rowHover="true"
                  [resource]="'valueset'"
                  [searchText]="''"
                  [load]="loading"
                  [executeActions]="executeActions"
                  (rowClicked)="onRowClicked($event)"
                  (selectAllRowsClicked)="onSelectAllRowsClicked($event)"
                  (pageChanged)="onPageChanged($event)"
                  [selectedRows]="selectedRows">
    </gen-worklist>
</ng-container>
<ng-container *ngIf="loading">
    <gen-overlay-loader [showOverlay]="true"></gen-overlay-loader>
</ng-container>
